import React, { useEffect, useState } from 'react';
import {
  VStack,
  Text,
  Box,
  Select,
  FormControl,
  FormLabel,
  Flex,
} from '@chakra-ui/react';
import axiosInstance from '../../../api/AxiosInstance';
import TablaProgramasCulturales from './TablaProgramasCulturales';

const ProgramasCulturales: React.FC = () => {
  const [planes, setPlanes] = useState<any[]>([]);
  const [planSeleccionado, setPlanSeleccionado] = useState<any>(null);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    setCargando(true);
    axiosInstance
      .get('/cultura/plan-anual')
      .then((res) => setPlanes(res.data || []))
      .catch(() => setPlanes([]))
      .finally(() => setCargando(false));
  }, []);

  const handleSeleccionarPlan = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const id = Number(e.target.value);
    const plan = planes.find((p) => p.id === id) || null;
    setPlanSeleccionado(plan);
  };

  return (
    <VStack spacing={6} align="stretch" px={{ base: 2, md: 4 }} pt={79} pb={4}>
      {/* Selector de plan */}
      <Box bg="white" borderRadius="md" p={4} boxShadow="sm">
        <Flex align="flex-end" gap={4} flexWrap="wrap">
          <FormControl w={{ base: 'full', md: '400px' }}>
            <FormLabel fontSize="sm" fontWeight="semibold">
              Selecciona el Plan Anual de Cultura
            </FormLabel>
            <Select
              placeholder={cargando ? 'Cargando planes...' : 'Selecciona un plan...'}
              onChange={handleSeleccionarPlan}
              isDisabled={cargando}
            >
              {planes.map((plan) => (
                <option key={plan.id} value={plan.id}>
                  {plan.anio} — {plan.nombrePlan}
                </option>
              ))}
            </Select>
          </FormControl>
        </Flex>
      </Box>

      {/* Tabla de programas */}
      {planSeleccionado ? (
        <TablaProgramasCulturales
          idPlan={planSeleccionado.id}
          nombrePlan={planSeleccionado.nombrePlan}
        />
      ) : (
        <Box bg="white" borderRadius="md" p={8} textAlign="center" boxShadow="sm">
          <Text color="gray.400">Selecciona un Plan Anual para ver y gestionar sus programas culturales</Text>
        </Box>
      )}
    </VStack>
  );
};

export default ProgramasCulturales;
